import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { RuntimeWidget } from 'client/types';
import { Div } from 'client/widget-components/basicComponents';
import React from 'react';
import withErrorBoundary from '../../widget-components/components/ErrorBoundary/withErrorBoundary';
import FilterSortMenu from './components/FilterSortMenu';
import TriggerButton from './components/TriggerButton';
import { FilterSortContext } from './components/utils/filterSortContext';
import { FilterSortExtensionData } from './components/utils/types';
import { WidgetStyles } from './components/utils/types/styles';
import useFilterSortWidget from './useFilterSortWidget';

export interface RuntimeFilterSortProps extends FilterSortExtensionData {
    widgetId: string;
    showButtonHoverEffect?: boolean;
    _styles?: WidgetStyles;
}

export const RuntimeFilterSort: RuntimeWidget<RuntimeFilterSortProps> = (
    props: RuntimeFilterSortProps
) => {
    const {
        widgetId,
        isDesignOpen,
        premiumWidget,
        currentPageType,
        _styles = {},
    } = props;
    const {
        filterSortLogic,
        onBtnClick,
        showWarning,
        setIsMenuOpen,
        shouldRenderMenu,
        openedMenuItemId,
        toggleMenuItem,
    } = useFilterSortWidget(props);

    const widgetContext = {
        styles: _styles,
        inDesignMode: isDesignOpen,
        hasProducts: props.hasProducts,
        isPremiumWidget: premiumWidget,
        currentPageType,
        openedMenuItemId,
        toggleMenuItem,
    };

    return (
        <FilterSortContext.Provider value={widgetContext}>
            <Div styles={wrapperDefaultStyles}>
                <TriggerButton
                    onClick={onBtnClick}
                    showWarning={showWarning}
                    selectedCount={filterSortLogic?.selectedCount}
                    text={props.buttonText}
                    styleWrapperSelector={`filter-sort-trigger-${widgetId}`}
                    showButtonHoverEffect={props.showButtonHoverEffect}
                />
            </Div>
            {shouldRenderMenu && filterSortLogic && (
                <FilterSortMenu
                    filterSortLogic={filterSortLogic}
                    props={{
                        ...props,
                        styleWrapperSelector: `filter-sort-menu-${widgetId}`,
                        setIsMenuOpen,
                    }}
                />
            )}
        </FilterSortContext.Provider>
    );
};

const wrapperDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        width: '100%',
        height: '100%',
        minWidth: 'fit-content',
    },
};

export default withErrorBoundary({
    Comp: RuntimeFilterSort,
    logProps: true,
    componentName: 'FilterSort',
    additionalInfoToLog: {
        tag: 'native-ecom',
    },
});
